import 'flowbite';

window.getSearchEngineSource = () => {
    const referrer = document.referrer;

    if (!referrer) return 'direct';

    const engines = [
        { name: 'google',     pattern: /google\./i },
        { name: 'bing',       pattern: /bing\.com/i },
        { name: 'yahoo',      pattern: /yahoo\.com/i },
        { name: 'yandex',     pattern: /yandex\./i },
        { name: 'duckduckgo', pattern: /duckduckgo\.com/i },
        { name: 'baidu',      pattern: /baidu\.com/i },
    ];

    const found = engines.find(e => e.pattern.test(referrer));
    return found ? found.name : 'other';
}

document.addEventListener('readystatechange', function() {
    const hamburgerButton = document.getElementById('hamburger-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const closeButton = document.getElementById('mobile-menu-close');
    const mobileMenuLinks = mobileMenu.querySelectorAll('a[href^="#"]');

    const instanceOptions = {
        id: 'mobile-menu',
        override: true
    };

    const collapse = new Collapse(mobileMenu, hamburgerButton, {}, instanceOptions);

    hamburgerButton.addEventListener('click', function() {
        collapse.expand();
    });

    closeButton.addEventListener('click', function () {
        collapse.collapse();
    })

    mobileMenuLinks.forEach(link => {
        link.addEventListener('click', function() {
            collapse.collapse();
        });
    });

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        const newsletterForm = document.getElementById('newsletter-form');

        if (newsletterForm) {
            newsletterForm.addEventListener('submit', async function(e) {
                e.preventDefault(); // Останавливаем перезагрузку страницы

                const form = e.target;
                const emailInput = document.getElementById('email-address');
                const button = form.querySelector('button[type="submit"]');
                const formContainer = document.getElementById('newsletter-form-container');
                const successContainer = document.getElementById('newsletter-success-container');

                // Получаем CSRF токен из мета-тега
                const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
                const csrfToken = csrfTokenMeta ? csrfTokenMeta.getAttribute('content') : '';

                // Визуальная индикация загрузки
                const originalBtnText = button.innerText;
                button.disabled = true;
                button.innerText = 'Sending...';

                try {
                    const response = await fetch('/blog/subscribe', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': csrfToken,
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            email: emailInput.value
                        })
                    });

                    if (response.ok) {
                        // Успех: переключаем видимость блоков
                        formContainer.classList.add('hidden');
                        successContainer.classList.remove('hidden');
                        // Анимация появления (опционально)
                        successContainer.classList.add('animate-fade-in-up');
                    } else {
                        // Обработка ошибок сервера (например, 422 validation error)
                        console.error('Subscription failed');
                        button.innerText = 'Error. Try again';
                        setTimeout(() => {
                            button.disabled = false;
                            button.innerText = originalBtnText;
                        }, 3000);
                    }

                } catch (error) {
                    console.error('Network error:', error);
                    button.innerText = 'Network Error';
                    setTimeout(() => {
                        button.disabled = false;
                        button.innerText = originalBtnText;
                    }, 3000);
                }
            });
        }
    }

    window.goToStep2 = (topicName) => {
        const step1 = document.getElementById('relocation-step-1');
        const step2 = document.getElementById('relocation-step-2');
        const display = document.getElementById('selected-topic-display');

        if (display) display.innerText = topicName;

        step1.classList.add('hidden');
        step2.classList.remove('hidden');

        try {
            if (typeof gtag === 'function') {
                gtag('event', 'course_theme_selected', {});
            }
        } catch (error) {
            console.error('GA4 Error:', error);
        }
    }

    // Логика подписки
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
        const courseletterForm = document.getElementById('relocation-newsletter-form');

        if (courseletterForm) {
            courseletterForm.addEventListener('submit', async function(e) {
                e.preventDefault();

                const form = e.target;
                const emailInput = document.getElementById('email-address');
                const button = form.querySelector('button[type="submit"]');

                const step2 = document.getElementById('relocation-step-2');
                const step3 = document.getElementById('relocation-step-3');

                // Получаем CSRF токен
                const csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
                const csrfToken = csrfTokenMeta ? csrfTokenMeta.getAttribute('content') : '';

                // Индикация загрузки
                const originalBtnText = button.innerText;
                button.disabled = true;
                button.innerText = 'Sending...';

                try {
                    const response = await fetch('/blog/subscribe', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': csrfToken,
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            email: emailInput.value,
                            topic: document.getElementById('selected-topic-display').innerText
                        })
                    });

                    if (response.ok) {
                        // Успех: переходим к финальному шагу
                        step2.classList.add('hidden');
                        step3.classList.remove('hidden');

                        try {
                            if (typeof gtag === 'function') {
                                gtag('event', 'course_subscription', {});
                            }
                        } catch (error) {
                            console.error('GA4 Error:', error);
                        }
                    } else {
                        throw new Error('Server error');
                    }

                } catch (error) {
                    console.error('Subscription failed:', error);
                    button.innerText = 'Error. Try again';
                    setTimeout(() => {
                        button.disabled = false;
                        button.innerText = originalBtnText;
                    }, 3000);
                }
            });
        }
    }
})

